import { createSlice } from "@reduxjs/toolkit";
import Api from "../../api/Api";

type State = {
    userInfoFetched : boolean,
    data : Object,
    isLoading: boolean,
    error: Object | null
}

// Slice
const slice = createSlice({
    name: "user",
    initialState: {
        userInfoFetched: false,
        data: {},
        isLoading: true,
        error: null,
    },
    reducers: {
        fetchUserStart: (state: State) => {
            state.isLoading = true;
        },
        fetchUserSuccess: (state: State, action) => {
            state.userInfoFetched = true;
            state.isLoading = false;
            state.data = action.payload;
        },
        fetchUserFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload;
        }
    },
});

export default slice.reducer;

// Actions
const {
    fetchUserStart,
    fetchUserSuccess,
    fetchUserFailed
} = slice.actions;

export const getUser = () => async (dispatch: Function) => {
    try {
        dispatch(fetchUserStart());
        const api = new Api();
        const result = await api.getUser();
        dispatch(fetchUserSuccess(result));
    } catch (err: any) {
        dispatch(fetchUserFailed(err));
    }
};
